import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <a href="https://github.com/Kabir4874" target="_blank" rel="noreferrer" aria-label="GitHub profile">
      <AiFillGithub />
    </a>
    <a href="https://www.linkedin.com/in/kabir4874/" target="_blank" rel="noreferrer">
      <BsLinkedin />
    </a>
    <a href="https://www.facebook.com/mdridoy1236" target="_blank" rel="noreferrer">
      <FaFacebookF />
    </a>
    <a href="https://www.instagram.com/kabirahmedridoy/" target="_blank" rel="noreferrer">
      <BsInstagram />
    </a>
  </div>
);

export default SocialMedia;
